import { ref, watch } from '@vue/composition-api'
import store from '@/store'


/**
 * composable function para los datatables.
 * @param {string} metodo - Es el método del dispatch al que hay que llamar para recuperar los datos de la api
 * @returns {any}
 */
const useTable = (metodo) => {

    const tabla = ref({
        items: [],
        count: 0,
        headers: [],
        filtros: {
            limit: 10,
            offset: 0
        }
    });

    let last_filtros = {};

    /**
     * Recupera los datos de la api
     * @param filtros
     * @returns {Promise<[]>}
     */
    const get_items = async (filtros = {}) => {

        const filtros_request = { ...filtros, ...tabla.value.filtros }
        last_filtros = filtros_request

        const response = await store.dispatch(metodo, {
            params: filtros_request
        })
        tabla.value.items = response.results
        tabla.value.count = response.count

        return tabla.value.items
    }

    watch(

        /**
         * Escucha cambios en la tabla cuando se hace clic en una columna para la ordenación
         */
        () => tabla.value.options,
        (value, old_value) => {

            tabla.value.filtros['limit'] = value['itemsPerPage']
            tabla.value.filtros['offset'] = ((value['page'] - 1) * value['itemsPerPage'])

            if (value['sortBy'].length) {
                let desc = value['sortDesc'][0] === true ? '-' : ''
                // Modificamos el campo de ordenación si es de un objeto complejo
                let field = value['sortBy'][0]
                switch (field){
                    case 'cliente.text':
                        field = 'cliente__nombre'
                        break;
                    case 'user_comprador.text':
                        field = 'user_comprador__nombre'
                        break;
                    case 'forma_pago.text':
                        field = 'forma_pago'
                        break;
                }
                tabla.value.filtros['ordering'] = `${desc}${field
                    .split(".")
                    .join("__")}`;
            }
            let filtros = { ...last_filtros }

            // Si no tiene old value, es cuando se está construyendo la tabla y no llamamos a la api
            if(!old_value) return

            get_items(filtros)
        }
    )

    return {
        tabla,
        get_items
    }
}

export default useTable
